import { CLASSES_CORE } from './constants';

export default class DpitTarget {

	/**
	 * Initialize target object
	 *
	 * @param {Element} element
	*/
	constructor(element) {
		this.element = element;
		const computedStyle = getComputedStyle(element);
		const cssPosition = computedStyle.getPropertyValue('position');
		this.analysis = {
			isSticky: cssPosition === 'sticky',
			isFixed: cssPosition === 'fixed',
			hasAltPosition: ['fixed', 'sticky', 'absolute'].includes(cssPosition),
			//isSvg: element.tagName.toLowerCase() === 'svg',
		};
	}

	process() {
		this.attrsBkp = {};
		this.element.classList.add(CLASSES_CORE.target);
		if (this.analysis.hasAltPosition) {
			this.addClassSafe(CLASSES_CORE.relativePosition);
		}
	}


	destroy() {
		this.element.classList.remove(CLASSES_CORE.target);
		this.removeClassSafe(CLASSES_CORE.relativePosition);
	}


	addClassSafe = (className) => {
		if (!this.element.classList.contains(className)) {
			const $element = $(this.element);
			const beforeOffset = $element.offset();
			this.element.classList.add(className);
			const afterOffset = $element.offset();

			let setOffset = false;
			if (Math.abs(afterOffset.top - beforeOffset.top) > 1) {
				this.attrsBkp.top = this.element.style.top;
				setOffset = true;
			}

			if (Math.abs(afterOffset.left - beforeOffset.left) > 1) {
				this.attrsBkp.left = this.element.style.left;
				setOffset = true;
			}
			if (setOffset) {
				$element.offset(beforeOffset);
			}
		}
	};

	removeClassSafe(className) {
		if (this.element.classList.contains(className)) {
			this.element.classList.remove(className);
		}
		if (this.attrsBkp) {
			Object.keys(this.attrsBkp).forEach(propName => {
				this.element.setAttribute(propName, this.attrsBkp[propName]);
			});
		}
	}
}